import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SuperadminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Sesión muerta: fuera de la plataforma, no a otra pantalla interna.
    if (!this.authService.isAuthenticated()) {
      this.authService.deleteAuth();

      return this.router.createUrlTree([this.authService.rutaSalida]);
    }

    const data = this.authService.getData();

    if (data && data.tipoUsuario === 'superadmin') {
      return true;
    }

    // Sesión válida pero sin permisos: se queda dentro, como hasta ahora.
    return this.router.createUrlTree(['/ventana2']);
  }
}
